export default __webpack_public_path__ + "4919ac44b32c89d88138646a70048c9c.jpeg";